



































































































































































































































































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import Switcher from '@/components/Switcher.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { UserModule } from '@/store/modules/user.module'
import Sortable from '@/directives/sortable'
import {
  EFacilityPayerTypePaymentOrder,
  EFacilityPayerTypePaymentResidentType,
  EFacilityPaymentAccountStatus,
  EFacilityPaymentOrder,
  EFacilityPaymentOrderBase,
  EOrigin,
  EUserPermissions,
  EUserStatus,
  IFacility,
  IFacilityAutoApplySettings,
  IFacilityPayerTypePaymentSetting,
  IPayerType,
  IUser,
  Dictionary,
  getIdFromEntityField,
} from '@zunta/configurations'

import Api from '@/api'
import { User } from '@/classes/User'
import Card from '@/components/Card.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import StatusWillowPaymentAccount from '@/components/statuses/StatusWillowPaymentAccount.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import Status from '@/components/statuses/Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import Editable from '@/components/inputsV2/Editable.vue'
import { getSelectContentLabel } from '@/utils/helpers'
import { makeErrorNotification } from '@/utils/notification'
import AutoPostDepositsModal from './components/AutoPostDepositsModal.vue'
import CCToggleOptionsModal from './components/CCToggleOptionsModal.vue'
import { CreditCardToggleOptions } from '@/utils/facility/facilityPayment/toggle-cc-options'
import { format24HourTo12Hour } from '@/utils/dateHelper'

@Component({
  directives: {
    sortable: new Sortable()
  },
  components: {
    Editable,
    Status,
    SelectV2,
    StatusWillowPaymentAccount,
    LoaderWrapper,
    Card,
    AutoPostDepositsModal,
    CCToggleOptionsModal,
    Icon,
    Checkbox,
    Switcher
  }
})
export default class FacilityPaymentSettingsV2 extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  EFacilityPaymentAccountStatus: any = EFacilityPaymentAccountStatus
  EFacilityPayerTypePaymentResidentType: any = EFacilityPayerTypePaymentResidentType
  EFacilityPaymentOrder: any = EFacilityPaymentOrder
  EFacilityPaymentOrderBase: any = EFacilityPaymentOrderBase
  EOrigin: any = EOrigin
  EStatusType: any = EStatusType
  getSelectContentLabel: Function = getSelectContentLabel
  format24HourTo12Hour = format24HourTo12Hour
  creditCardToggleOptions: CreditCardToggleOptions = {}
  makeErrorNotification = (message: string) => makeErrorNotification(this, message)
  facilityData: Partial<IFacility> = {}

  showAutoPostModal: boolean = false
  autoPostChange: boolean = false
  reloadPayerTypeList: boolean = false

  settings: Partial<IFacilityAutoApplySettings> = {}

  payerTypeSettings: Partial<IFacilityPayerTypePaymentSetting>[] = []

  isLoading: boolean = false
  isAccountLoading: boolean = false

  get editApplyBalancePermission () {
    return this.user.hasPermissionFor(EUserPermissions.EDIT_PAYMENT_SETTINGS)
  }

  get payerTypes () {
    return this.$store.state.facility.payerTypes as IPayerType[]
  }

  get allFacilities () {
    return this.$store.state.facility.facilities
  }

  get facilityUsers () {
    return this.$store.state.user.users
  }

  get facilityUsersItems (): IUser[] {
    return this.facilityUsers.reduce((facilityUsers: IUser[], facilityUser: IUser) => {
      if (facilityUser.isAllFacilities || (facilityUser.facilities && facilityUser.facilities.some(el => el.toString() === this.facilityId.toString()))) {
        return [...facilityUsers, {
          key: facilityUser.id,
          value: facilityUser.id,
          content: `${facilityUser.firstName} ${facilityUser.lastName}`
        }]
      }
      return facilityUsers
    }, []) || [] as IUser[]
  }

  get allFacilitiesListItems () {
    return this.allFacilities.map((facility: IFacility) => ({
      key: facility.id,
      value: facility.id,
      content: facility.name
    }))
  }

  get facilityId () {
    return this.$route.params.id
  }

  get activePayerTypeById () {
    return this.payerTypes.reduce((map, payerType) => {
      if (payerType.id && payerType.active) {
        map[payerType.id] = payerType
      }
      return map
    }, {} as Dictionary<IPayerType>)
  }

  get selectedFacility () {
    return this.$store.state.facility.selectedFacility
  }

  get storePayerTypeSettings () {
    return this.$store.state.facility.payerTypePaymentSettings
  }

  get storeFacilityAutoApplySetting () {
    return this.$store.state.facility.autoApplySettings
  }

  get currentPayerTypePaymentSettings () {
    return this.payerTypeSettings
      .filter(payerTypeSetting => {
        const payerTypeId = getIdFromEntityField(payerTypeSetting.payerType!).toString()
        return this.activePayerTypeById[payerTypeId] &&
          (payerTypeSetting.residentType === EFacilityPayerTypePaymentResidentType.BOTH ||
            payerTypeSetting.residentType === EFacilityPayerTypePaymentResidentType.CURRENT)
      })
      .sort((a: any, b: any) => a.order - b.order)
  }

  get dischargedPayerTypePaymentSettings () {
    return this.payerTypeSettings
      .filter(payerTypeSetting => {
        const payerTypeId = getIdFromEntityField(payerTypeSetting.payerType!).toString()
        return this.activePayerTypeById[payerTypeId] &&
          payerTypeSetting.residentType === EFacilityPayerTypePaymentResidentType.DISCHARGED
      })
      .sort((a: any, b: any) => a.order - b.order)
  }

  get facilityPaymentAccount () {
    return this.$store.state.facility.facilityPaymentAccount
  }

  get willowId () {
    return this.$store.state.facility.facilityPaymentAccount
      ? this.$store.state.facility.facilityPaymentAccount.willowAccountId
      : ''
  }

  get autoPostSelected () {
    return this.selectedFacility.depositAutoPost
  }

  get isRootAccess () {
    return this.user.isRootAccess()
  }

  get paymentOrderOptions () {
    return [{
      value: EFacilityPayerTypePaymentOrder.NEWEST,
      key: 'newest',
      content: 'Newest'
    }, {
      value: EFacilityPayerTypePaymentOrder.OLDEST,
      key: 'oldest',
      content: 'Oldest'
    }]
  }

  async mounted () {
    try {
      this.isLoading = true
      if (this.selectedFacility) {
        this.fetchAccount()
        await Promise.all([
          this.facilityModuleInstance.fetchFacilitiesPaymentAccounts(this.$store.state.facility.facilities.map((f: IFacility) => f.id)),
          this.facilityModuleInstance.fetchPayerTypes(this.selectedFacility.id),
          this.facilityModuleInstance.fetchFacilityAutoApplySettings(this.selectedFacility.id),
          this.userModuleInstance.getManagementUsersList({ status: EUserStatus.ACTIVE })
        ])
        this.payerTypeSettings = this.storePayerTypeSettings
        this.settings = this.storeFacilityAutoApplySetting
        this.$set(this.facilityData, 'paymentsReviewManager', this.selectedFacility.paymentsReviewManager)
        this.$set(this.facilityData, 'syncPaymentUser', this.selectedFacility.syncPaymentUser)
        this.$set(this.facilityData, 'depositAutoPost', this.selectedFacility.depositAutoPost)
      }
    } finally {
      this.isLoading = false
    }
  }

  async fetchAccount () {
    try {
      this.isAccountLoading = true
      await this.facilityModuleInstance.fetchFacilityPaymentAccount(this.selectedFacility.id)
    } finally {
      this.isAccountLoading = false
    }
  }

  async saveFacilityPaymentsSettings () {
    this.isLoading = true
    try {
      await this.facilityModuleInstance.updateFacility({
        id: this.selectedFacility.id as number,
        data: {
          paymentsReviewManager: this.facilityData.paymentsReviewManager,
          syncPaymentUser: this.facilityData.syncPaymentUser,
          depositAutoPost: this.facilityData.depositAutoPost
        }
      })
    } finally {
      this.isLoading = false
    }
  }

  openAutoPostDepositModal (value: any) {
    if (value !== this.selectedFacility.depositAutoPost) {
      this.autoPostChange = value
      this.showAutoPostModal = true
    }
  }

  setDepositAutoPost () {
    this.facilityData.depositAutoPost = this.autoPostChange
    this.showAutoPostModal = false
    this.saveFacilityPaymentsSettings()
  }

  initFromStore () {
    this.settings = this.storeFacilityAutoApplySetting
    this.payerTypeSettings = this.storePayerTypeSettings
    this.payerTypeSettings.forEach((payerTypeSetting: Partial<IFacilityPayerTypePaymentSetting>) => {
      payerTypeSetting.facility = this.selectedFacility.id
      delete payerTypeSetting.id
    })

    this.$set(this.facilityData, 'paymentsReviewManager', this.selectedFacility.paymentsReviewManager)
    this.$set(this.facilityData, 'syncPaymentUser', this.selectedFacility.syncPaymentUser)
    this.$set(this.facilityData, 'depositAutoPost', this.selectedFacility.depositAutoPost)

    this.$forceUpdate()
  }

  changeBiggestBalanceSetting (
    propName: keyof Pick<IFacilityAutoApplySettings, 'currentResidentPaymentOrderBase' | 'dischargedResidentPaymentOrderBase'>,
    active: boolean
  ) {
    if (!this.settings.distinctionBetweenCurrentAndDischarged) {
      this.settings.currentResidentPaymentOrderBase = active ? EFacilityPaymentOrderBase.BIGGEST_BALANCE : EFacilityPaymentOrderBase.PAYER_TYPE
      this.settings.dischargedResidentPaymentOrderBase = active ? EFacilityPaymentOrderBase.BIGGEST_BALANCE : EFacilityPaymentOrderBase.PAYER_TYPE
    } else {
      this.settings[propName] = active ? EFacilityPaymentOrderBase.BIGGEST_BALANCE : EFacilityPaymentOrderBase.PAYER_TYPE
    }
    this.save()
  }

  changeDistinctionBetweenCurrentAndDischarged (checked: boolean) {
    this.settings.distinctionBetweenCurrentAndDischarged = checked
    if (!checked) {
      this.settings.dischargedResidentPaymentOrder = this.settings.currentResidentPaymentOrder
      this.settings.dischargedResidentPaymentOrderBase = this.settings.currentResidentPaymentOrderBase
      this.payerTypeSettings = this.payerTypeSettings.filter((payerTypeSetting: Partial<IFacilityPayerTypePaymentSetting>) => (
        payerTypeSetting.residentType !== EFacilityPayerTypePaymentResidentType.DISCHARGED
      ))
      this.payerTypeSettings.forEach((payerTypeSetting: Partial<IFacilityPayerTypePaymentSetting>) => (
        payerTypeSetting.residentType = EFacilityPayerTypePaymentResidentType.BOTH
      ))
    } else {
      this.payerTypeSettings.forEach((payerTypeSetting: Partial<IFacilityPayerTypePaymentSetting>) => (
        payerTypeSetting.residentType = EFacilityPayerTypePaymentResidentType.CURRENT
      ))
      this.payerTypeSettings = this.payerTypeSettings.concat(this.payerTypeSettings.map((payerTypeSetting: Partial<IFacilityPayerTypePaymentSetting>) => ({
        ...payerTypeSetting,
        residentType: EFacilityPayerTypePaymentResidentType.DISCHARGED
      })))
    }
    this.$forceUpdate()
    this.save()
  }

  updateCurrentPayerTypeSettingsSelectedOrder (event: any) {
    const { oldIndex, newIndex } = event
    const payerTypeSettings = this.currentPayerTypePaymentSettings
    const order = payerTypeSettings[newIndex].order

    if (newIndex > oldIndex) {
      for (let i = oldIndex; i < newIndex; i++) {
        const idx = i + 1
        // @ts-ignore
        payerTypeSettings[idx].order = payerTypeSettings[idx].order - 1
      }
    } else {
      for (let i = newIndex; i < oldIndex + 1; i++) {
        // @ts-ignore
        payerTypeSettings[i].order = payerTypeSettings[i].order + 1
      }
    }
    payerTypeSettings[oldIndex].order = order

    this.save()
  }

  updateDischargedPayerTypeSettingsSelectedOrder (event: any) {
    const { oldIndex, newIndex } = event
    const payerTypeSettings = this.dischargedPayerTypePaymentSettings
    const order = payerTypeSettings[newIndex].order

    if (newIndex > oldIndex) {
      for (let i = oldIndex; i < newIndex; i++) {
        const idx = i + 1
        // @ts-ignore
        payerTypeSettings[idx].order = payerTypeSettings[idx].order - 1
      }
    } else {
      for (let i = newIndex; i < oldIndex + 1; i++) {
        // @ts-ignore
        payerTypeSettings[i].order = payerTypeSettings[i].order + 1
      }
    }
    payerTypeSettings[oldIndex].order = order

    this.save()
  }

  getPayerTypeName (payerTypeId: number) {
    const payerType = this.activePayerTypeById[payerTypeId]
    return payerType ? payerType.payer_name : ''
  }

  async save () {
    if (!this.user.hasPermissionFor(EUserPermissions.EDIT_PAYMENT_SETTINGS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Modify Payment Settings`,
        icon: 'warning'
      })
      return
    }

    try {
      this.isLoading = true
      const response = await this.facilityModuleInstance.saveFacilityAutoApplySettings({
        settings: this.settings,
        payerTypeSettings: this.payerTypeSettings
      })

      if (response !== 'OK') {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Something went wrong',
          header: `Auto Apply Settings`,
          icon: 'warning'
        })
        return
      }
      await this.facilityModuleInstance.fetchFacilityAutoApplySettings(this.selectedFacility.id)
      this.initFromStore()
    } finally {
      this.isLoading = false
    }
  }

  async saveEnableEditing (event: boolean) {
    try {
      this.isLoading = true
      await this.facilityModuleInstance.setPaymentAccountEnableEditing({
        facilityId: this.facilityId,
        enableEditing: event
      })
    } finally {
      this.isLoading = false
    }
  }

  beforeDestroy () {
    this.facilityModuleInstance.resetAutoApplySettings()
  }

  async updateFacility (fieldName: string, item: any) {
    try {
      this.isLoading = true
      await this.facilityModuleInstance.updateFacility({
        id: this.selectedFacility.id as number,
        data: {
          [fieldName]: item
        }
      })
    } finally {
      this.isLoading = false
    }
  }
}
